import React, {useRef, useState} from 'react'
import useScriptLoader from '../../hooks/use-script-loader'
import {getAssetUrl} from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils'
import useMutationObserver from '../../custom-hooks/use-mutation-observer'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import LoadingSpinner from '../loading-spinner'

const ThreekitWidget = () => {
    const officinaScriptUrl = getAssetUrl(
        `static/vendors/threekit/${
            /(localhost|sit|stg)/.test(window.location.hostname) ? 'dev' : 'prod'
        }/treble-app.js`,
    )
    useScriptLoader(officinaScriptUrl)

    const [isLoading, setLoading] = useState(true)

    const mutationRef = useRef()

    const mutationCallback = (mutation) => {
        const targetId = mutation?.[0].target?.id
        if (targetId !== 'tk-treble-root') setLoading(false)
    }

    useMutationObserver(mutationRef, mutationCallback)

    return (
        <>
            {isLoading && (
                <Box position="absolute" height="75vh" width="100%">
                    <LoadingSpinner />
                </Box>
            )}
            <div
                ref={mutationRef}
                id="tk-treble-root"
                data-closing-url="https://www.delonghi.com/it-it/officina"
                data-terms-and-conditions-url="https://www.delonghi.com/it-it/condizioni-generali-di-vendita-officina"
            ></div>
        </>
    )
}

export default ThreekitWidget
